import React, { useState, useRef } from "react";
import { useSwipeable } from "react-swipeable";

//Data
import { contestExampleData } from "./exampleData";

//Styles
import "./ContestExample.scss";

//Components
import CardsStackCarousel from "common-components/CardsStackCarousel/Cards";

function ContestExample() {
  const [currentReview, setCurrentReview] = useState(0);
  const carousel = useRef();

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      carousel.current.next();
      setCurrentReview(currentReview + 1 > contestExampleData.length - 1 ? 0 : currentReview + 1);
    },
    onSwipedRight: () => {
      carousel.current.prev();
      setCurrentReview(currentReview - 1 < 0 ? contestExampleData.length - 1 : currentReview - 1);
    },
    trackMouse: true
  });
  return (
    <div className="for-swiping-wrapper" {...swipeHandlers}>
      <CardsStackCarousel alignment="vertical" spread="narrow" ref={carousel}>
        {contestExampleData.map(({ text, avatar, name, company, designers, entries, budget, images }, index) => (
          <section key={index} className="contest-example">
            <div className="reviews-wrapper">
              <div className="one-review-wrapper">
                <div className="col review">
                  <h3>“{text}”</h3>
                  <div className="person-info">
                    <img src={avatar} alt={name} />
                    <div className="name-company">
                      <b>{name}</b>
                      <p>{company}</p>
                    </div>
                  </div>
                  <div className="number">
                    <span role="img" aria-label="Artist Emoji">
                      👩‍🎨
                    </span>
                    {designers} designers
                  </div>
                  <div className="number">
                    <span role="img" aria-label="Brush Emoji">
                      🖌
                    </span>
                    {entries} entries
                  </div>
                  <div className="number">
                    <span role="img" aria-label="Money Emoji">
                      💸
                    </span>
                    {budget} budget
                  </div>
                </div>
                <div className="col images">
                  {images.map((url, index) => (
                    <div key={index} className={"area-" + index}>
                      <img src={url} alt="" loading="lazy" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="clickers">
              {contestExampleData.map((el, index) => (
                <button
                  key={index}
                  className={index === currentReview ? "active" : null}
                  onClick={() => {
                    carousel.current.goTo(index);
                    setCurrentReview(index);
                  }}
                >
                  <span></span>
                </button>
              ))}
            </div>
            <button
              className="flip prev"
              onClick={() => {
                carousel.current.prev(index);
                setCurrentReview(index - 1 < 0 ? contestExampleData.length - 1 : index - 1);
              }}
            />
            <button
              className="flip next"
              onClick={() => {
                carousel.current.next(index);
                setCurrentReview(index + 1 > contestExampleData.length - 1 ? 0 : index + 1);
              }}
            />
          </section>
        ))}
      </CardsStackCarousel>
    </div>
  );
}

export default ContestExample;
